module.exports = __webpack_public_path__ + "media/images/tutorial_body_sp2-04-7060343b96a79799c05794c1d657839f.png";